import React from "react";
import { FaEnvelope, FaTelegram, FaTwitter } from "react-icons/fa";

const CustomFooter = () => {
    
    return (
        <div className="footer-wrapper">
            <div className="themesflat-container h-full flex items-center footer-icons-wrapper">
                <div className="icon-wrapper font-face-poppins">
                    <FaTelegram/>
                    <span>@luncsphere</span>
                </div>
                <div className="icon-wrapper font-face-poppins">
                    <FaTwitter/>
                    <span>t.me/luncsphere</span>
                </div>
                <div className="icon-wrapper font-face-poppins">
                    <FaEnvelope/>
                    <span>hello@luncsphere.com</span>
                </div>
            </div>
        </div>
    )
}

export default CustomFooter;